import React, { Component } from 'react';
export default class Currency extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showeble: 0
        };
    }
    componentWillReceiveProps() {
        let amount = parseFloat(this.props.amount)
        if (!!this.props.sharing && parseFloat(this.props.sharing) > 0) {
            amount = (parseFloat(this.props.sharing) * amount) / 100
        }
        if (!!this.props.showInverse && this.props.showInverse === true) {
            amount = 0 - amount
        }
        amount = parseFloat(amount).toFixed(2)
        this.setState({ showeble: amount })
    }
    componentDidMount() {
        let amount = parseFloat(this.props.amount)
        if (!!this.props.sharing && parseFloat(this.props.sharing) > 0) {
            amount = (parseFloat(this.props.sharing) * amount) / 100
        }
        if (!!this.props.showInverse && this.props.showInverse === true) {
            amount = 0 - amount
        }
        amount = parseFloat(amount).toFixed(2)
        this.setState({ showeble: amount })
    }
    render() {
        return (
            <span className={!!this.props.classPropName ? this.props.classPropName : ""} style={this.props.showColor && this.state.showeble < 0 ? { color: "red" } : this.props.showColor && this.state.showeble > 0 ? { color: "green" } : {}}>{this.state.showeble}</span>
        )
    }
}
